import { render, staticRenderFns } from "./Favoris.vue?vue&type=template&id=3fe364f6&scoped=true&"
import script from "./Favoris.vue?vue&type=script&lang=js&"
export * from "./Favoris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe364f6",
  null
  
)

export default component.exports